exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree-box[data-v-0d2e152b]{height:calc(100% - 46px)}", ""]);

// exports
